import { render, staticRenderFns } from "./DealStatusHandle.vue?vue&type=template&id=85621f80&scoped=true"
import script from "./DealStatusHandle.vue?vue&type=script&lang=js"
export * from "./DealStatusHandle.vue?vue&type=script&lang=js"
import style0 from "./DealStatusHandle.vue?vue&type=style&index=0&id=85621f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85621f80",
  null
  
)

export default component.exports